import { CSSProperties } from 'react'

import classNames from 'classnames'

import './Table.scss'

interface TableProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
}

export const Table: React.FC<TableProps> = ({ className, style, children }) => {
  return (
    <table className={classNames('data-table', className)} style={{ ...style }}>
      {children}
    </table>
  )
}
